import React from 'react'

const Jva_rmz = () => {
    return (
        <div className='container'>
            <h1>Rat inside a maze (Using Backtracking Algorithm)</h1>
            <p>Consider a situation where a rat is dropped at the source and the rat has to reach the destination node in the best path possible. The black nodes in the figure mean to block the way for the rat and hence rat has to reach destination following the path in white nodes. Write a program such that the rat reaches the destination with the best possible route in the given maze.</p>
            <p><strong>Solution:</strong></p>
            <p><strong>Step 1</strong>: Convert the given maze into a readable matrix where the black nodes are represented by zero's and white nodes are represented by one. Now a program has to be written to traverse on the ones to reach the destination node.&nbsp;</p>
            <p>This problem can typically be solved by two methods.&nbsp;</p>
            <p>One is by the native method of finding out all possible paths and then finding the minimum distance or minimum hops path that needs to be taken by the rat to reach the destination. This procedure is complex in nature and a lot of memory is being used to store all possible paths and later check the best possible route in it.</p>
            <p>Instead of the above method, we could use backtracking algorithm:</p>
            <p>Backtracking algorithm can be defined as an algorithm used to find all possible solutions in a problem. This algorithm traverses one node at a time and incrementally builds the solutions. In each step, if the algorithm recognises any block that might not be used to find the best path that block is cancelled, i.e in this case that block is also marked as '0'. This reduces the number of trails and avoids the system from storing all possible path traversals till the last step of the&nbsp;program.</p>
            <h2>Java Implementation of Backtracking solution</h2>
            <pre class="containers" spellcheck="false"><span class="comment">/* Java program to solve Rat in a Maze problem using
      backtracking */</span> <br />
   
   public <span class="hljs-class"><span class="keywords">class</span> <span class="hljs-title">RatMaze</span> <br />
   </span>&#123; <br />
       final int N = <span class="hljs-number">4</span>; <br />
    <br />
       <span class="comment">/* A utility function to print solution matrix <br />
          sol[N][N] */</span><span class="keywords">void</span> printSolution(int sol[][]) <br />
       &#123; <br />
           <span class="keywords">for</span> (int i = <span class="hljs-number">0</span>; i &lt; N; i++) <br />
           &#123; <br />
               <span class="keywords">for</span> (int j = <span class="hljs-number">0</span>; j &lt; N; j++) <br />
                   System.out.print(<span class="hljs-string">" "</span> + sol[i][j] + <br />
                                    <span class="hljs-string">" "</span>); <br />
               System.out.println(); <br />
           &#125; <br />
       &#125; <br />
    <br />
       <span class="comment">/* A utility function to check if x,y is valid <br />
           index for N*N maze */</span> <br />
       boolean isSafe(int maze[][], int x, int y) <br />
       &#123; <br />
           <span class="comment">// if (x,y outside maze) return falsereturn (x &gt;= 0 &amp;&amp; x &lt; N &amp;&amp; y &gt;= 0 &amp;&amp;</span> <br />
                   y &lt; N &amp;&amp; maze[x][y] == <span class="hljs-number">1</span>); <br />
       &#125; <br />
    <br />
       <span class="comment">/* This function solves the Maze problem using <br />
          Backtracking. It mainly uses solveMazeUtil() <br />
          to solve the problem. It returns false if no <br />
          path is possible, otherwise return true and <br />
          prints the path in the form of 1s. Please note <br />
          that there may be more than one solutions, this <br />
          function prints one of the feasible solutions.*/</span> <br />
       boolean solveMaze(int maze[][]) <br />
       &#123; <br />
           int sol[][] = &#123; &#123;<span class="hljs-number">0</span>, <span class="hljs-number">0</span>, <span class="hljs-number">0</span>, <span class="hljs-number">0</span>&#125;, <br /> <br />
               &#123;<span class="hljs-number">0</span>, <span class="hljs-number">0</span>, <span class="hljs-number">0</span>, <span class="hljs-number">0</span>&#125;, <br />
               &#123;<span class="hljs-number">0</span>, <span class="hljs-number">0</span>, <span class="hljs-number">0</span>, <span class="hljs-number">0</span>&#125;, <br />
               &#123;<span class="hljs-number">0</span>, <span class="hljs-number">0</span>, <span class="hljs-number">0</span>, <span class="hljs-number">0</span>&#125; <br />
           &#125;; <br />
    <br />
           <span class="keywords">if</span> (solveMazeUtil(maze, <span class="hljs-number">0</span>, <span class="hljs-number">0</span>, sol) == <span class="library">false</span>) <br />
           &#123; <br />
               System.out.print(<span class="hljs-string">"Solution doesn't exist"</span>); <br />
               <span class="keywords">return</span> <span class="library">false</span>; <br />
           &#125; <br />
    <br />
           printSolution(sol); <br />
           <span class="keywords">return</span> <span class="library">true</span>; <br />
       &#125; <br />
    <br />
       <span class="comment">/* A recursive utility function to solve Maze <br />
          problem */</span> <br />
       boolean solveMazeUtil(int maze[][], int x, int y, <br />
                             int sol[][]) <br />
       &#123; <br />
           <span class="comment">// if (x,y is goal) return trueif (x == N - 1 &amp;&amp; y == N - 1)</span> <br />
           &#123; <br />
               sol[x][y] = <span class="hljs-number">1</span>; <br />
               <span class="keywords">return</span> <span class="library">true</span>; <br />
           &#125; <br />
    <br />
           <span class="comment">// Check if maze[x][y] is validif (isSafe(maze, x, y) == true)</span> <br />
           &#123; <br />
               <span class="comment">// mark x,y as part of solution path</span> <br />
               sol[x][y] = <span class="hljs-number">1</span>; <br />
    <br />
               <span class="comment">/* Move forward in x direction */</span><span class="keywords">if</span> (solveMazeUtil(maze, x + <span class="hljs-number">1</span>, y, sol)) <br />
                   <span class="keywords">return</span> <span class="library">true</span>; <br />
    <br />
               <span class="comment">/* If moving in x direction doesn't give <br />
                  solution then  Move down in y direction */</span><span class="keywords">if</span> (solveMazeUtil(maze, x, y + <span class="hljs-number">1</span>, sol)) <br />
                   <span class="keywords">return</span> <span class="library">true</span>; <br />
    <br />
               <span class="comment">/* If none of the above movements work then <br />
                  BACKTRACK: unmark x,y as part of solution <br />
                  path */</span> <br />
               sol[x][y] = <span class="hljs-number">0</span>; <br />
               <span class="keywords">return</span> <span class="library">false</span>; <br />
           &#125; <br />
    <br />
           <span class="keywords">return</span> <span class="library">false</span>; <br />
       &#125; <br />
    <br />
       public <span class="keywords">static</span> <span class="keywords">void</span> main(<span class="hljs-built_in">String</span> args[]) <br />
       &#123; <br />
           RatMaze rat = <span class="keywords">new</span> RatMaze(); <br />
           int maze[][] = &#123; &#123;<span class="hljs-number">1</span>, <span class="hljs-number">0</span>, <span class="hljs-number">0</span>, <span class="hljs-number">0</span>&#125; <br />,
               &#123;<span class="hljs-number">1</span>, <span class="hljs-number">1</span>, <span class="hljs-number">0</span>, <span class="hljs-number">1</span>&#125;, <br />
               &#123;<span class="hljs-number">0</span>, <span class="hljs-number">1</span>, <span class="hljs-number">0</span>, <span class="hljs-number">0</span>&#125;, <br />
               &#123;<span class="hljs-number">1</span>, <span class="hljs-number">1</span>, <span class="hljs-number">1</span>, <span class="hljs-number">1</span>&#125; <br />
           &#125;; <br />
           rat.solveMaze(maze); <br />
       &#125; <br />
   &#125; <br />
   </pre>
   <p><p><strong>Output</strong>:</p></p>
   <pre class="output" spellcheck="false"> 1  0  0  0  <br />
 1  1  0  0  <br />
 0  1  0  0  <br />
 0  1  1  1 <br />
</pre>
        </div>
    )
}

export default Jva_rmz
